module.exports = __webpack_public_path__ + "img/tile_five.c235acfd.png";